// COPIED FILE - do not edit here.
// Master: _shared/ at the top level. Change it there, then run
// `node sync-shared.mjs`, or services will silently disagree about
// permissions and token formats.

/**
 * One error shape for the whole platform:
 *   { "error": { "code": "LIMIT_REACHED", "message": "plain English" } }
 * The frontend can always read error.message and show it to a human.
 */
export function fail(res: any, status: number, code: string, message: string) {
  return res.status(status).json({ error: { code, message } });
}
